import store from '../../store'
const locale = store.getState().main.locale

export const REPORT_STATUSES = {
    info: 'active',
    warning: 'warning',
    critical: 'critical',
    infested: 'infested',
    down: 'down',
    catch: 'catch'
}
